import { render, staticRenderFns } from "./AttendeeMenu.vue?vue&type=template&id=d8270272&scoped=true&lang=pug"
import script from "./AttendeeMenu.vue?vue&type=script&lang=ts"
export * from "./AttendeeMenu.vue?vue&type=script&lang=ts"
import style0 from "./AttendeeMenu.vue?vue&type=style&index=0&id=d8270272&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8270272",
  null
  
)

export default component.exports